<template>
  <div class="container">
    <header class="topTitle">
      <img :src="instrucLogo" class="instrucLogo" />
      <span>检测须知</span>
      <!-- <span>HyperQ检测流程</span> -->
    </header>

    <main class="mainContent">
      <section style="margin-top:23px;">
        <header class="subTitle">
          <span>HyperQ检测流程</span>
        </header>

        <van-row style="margin-top:18px;">
          <van-col span="4" offset="2">
            <img :src="step1" class="stepIcon1" />
          </van-col>
          <van-col span="18" style="margin-top: 5px">
            <span class="stepName">第一步</span><br />
            <span cass="stepDesc">贴电极片。</span>
          </van-col>
        </van-row>

        <van-row>
          <van-col span="4" offset="2">
            <img :src="step2" class="stepIcon2" />
          </van-col>
          <van-col span="18" style="margin-top: 3px">
            <span class="stepName">第二步</span><br />
            <span cass="stepDesc">静息心电3分钟。</span>
          </van-col>
        </van-row>

        <van-row style="margin-top: 14px">
          <van-col span="4" offset="2">
            <img :src="step3" class="stepIcon3" />
          </van-col>
          <van-col span="18">
            <span class="stepName">第三步</span><br />
            <span cass="stepDesc">运动心电6分钟，达到目标心率。</span>
          </van-col>
        </van-row>

        <van-row style="margin-top: 14px">
          <van-col span="4" offset="2">
            <img :src="step4" class="stepIcon4" />
          </van-col>
          <van-col span="18">
            <span class="stepName">第四步</span><br />
            <span cass="stepDesc">休息3分钟，查看结果。</span>
          </van-col>
        </van-row>
      </section>
      <van-divider></van-divider>
      <section>
        <header class="subTitle">
          <span>温馨提示</span>
        </header>
        <article>
          <ul class="noteContainer">
            <li><b>1</b>、检测前24-48小时停用心脏活性药，β受体阻滞剂，胺碘酮等药物；</li>
            <li><b>2</b>、检测前1小时内禁食，2小时内禁止抽烟，饮咖啡，浓茶，饮酒，兴奋性饮料；</li>
            <li><b>3</b>、请穿着宽松衣物（运动服更佳）、运动鞋或平底鞋；</li>
            <li><b>4</b>、女士请勿穿连体裤，连衣裙和丝袜（月经期，妊娠期禁止检测）；</li>
            <li><b>5</b>、检测前一天请勿熬夜或情绪激动；</li>
            <li><b>6</b>、12小时内剧烈运动者，不宜参加检测；</li>
          </ul>

          <!-- <ul class="noteContainer">
            <li>1.如有任何心血管疾病，测试前请告诉工作人员；</li>
            <li>2.运动负荷强度较大，请评估自身情况，谨慎测试；</li>
            <li>3.测试前一小时之内请勿进食及饮用刺激性饮料；</li>
            <li>4.测试期间出现心绞痛、眩晕等不适症状，请立即告知；</li>
            <li>5.体验前48小时请勿服用冠心病血管扩充药物。</li>
          </ul> -->
        </article>
      </section>
    </main>
    <!-- <van-divider></van-divider> -->
    <footer @click="nextStep" class="fixedFooter">
      我知道了
    </footer>
  </div>
</template>

<script>
import instrucLogo from "../../../assets/instructions/logo.png";
import step1 from "../../../assets/instructions/logo2.png";
import step2 from "../../../assets/instructions/logo3.png";
import step3 from "../../../assets/instructions/logo4.png";
import step4 from "../../../assets/instructions/logo5.png";

export default {
  name: "Instructions",
  props: {
    examUuid: String,
  },
  data() {
    return {
      instrucLogo,
      step1,
      step2,
      step3,
      step4,
    };
  },
  methods: {
    nextStep() {
      this.$router.push({path:"/appIndex/timeSelect"})

    },
  },
  created() {},
};
</script>

<style scoped lang="less">
// * {
//   font-family: "PingFang-SC-Semibold";
// }

.container {
  position: relative;
  width: 100%;
  min-height: 100%;
}

.container .title {
  text-align: center;
}

.instrucLogo {
  width: 23px;
  height: auto;
  display: inline-block;
  margin-top: 3px;
  vertical-align: middle;
}
.topTitle {
  height: 30px;
  background: linear-gradient(to right, #f78a8e 0%, #f5686d 50%, #dd2228 100%);
  box-sizing: content-box;
  padding: 12px 0 10px 0;
  line-height: 100%;
}
.topTitle span {
  font-size: 22px;
  color: white;
  vertical-align: middle;
}

header {
  text-align: center;
}

header.subTitle {
  font-size: 22px;
}

.mainContent {
  margin-bottom: 10px;
  height: 100%;
}

.stepIcon1 {
  width: 33px;
  height: 54px;
}

.stepIcon2 {
  width: 35px;
  height: 32px;
  margin-top: 8px;
}

.stepIcon3 {
  width: 43px;
  height: 44px;
}

.stepIcon4 {
  width: 33px;
  height: 40px;
  margin-top: 4px;
}

.stepName {
  color: red;
  font-size: 18px;
}

.stepDesc {
  font-size: 15.5px;
}
.noteContainer {
  padding: 10px 30px 10px 31.25px;
  font-size: 15.5px;
}
.noteContainer li{
  line-height:24px;
  margin-bottom: 8px;
}

footer {
  position: sticky;
  bottom: 0;
  left: 50%;
  margin-top: 10px;
  padding: 7px 0 7px 0;
  border-top: 1px solid #ebedf0;
  text-align: center;
  color: #1875c8;
  font-size: 18px;
  font-weight: 50;
  background-color: white;
}
</style>
